/* A tinted callout that points somewhere (SYS1's "for someone" note, SYS2's and SYS3's "Next"):
   the boards' pale cyan with a cyan line, navy words, at most one way on. Tokens only. */
.signpost {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px 16px;
  padding: 18px 22px;
  border: 1px solid color-mix(in srgb, var(--brand-cyan) 28%, var(--white));
  border-radius: var(--radius-md);
  background: color-mix(in srgb, var(--brand-cyan) 10%, var(--white));
  color: var(--brand-navy);
}

.mark {
  display: grid;
  flex: none;
  place-items: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: var(--brand-petrol);
  color: var(--white);
}

.words {
  display: flex;
  flex: 1 1 260px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  min-width: 0;
}

.title {
  margin: 0;
  color: var(--brand-navy);
  font-size: 17px;
  font-weight: 700;
  line-height: 1.3;
}

.text {
  font-size: 15px;
  line-height: 1.6;
}

.text > p {
  margin: 0;
}

.button {
  margin-top: 4px;
}

/* The quiet way on: a small uppercase link at the end of the line, a full 44 px target. */
.quiet {
  display: inline-flex;
  align-items: center;
  min-height: 44px;
  color: var(--brand-navy);
  font-family: var(--font-ui);
  font-size: 13px;
  letter-spacing: 0.08em;
  text-decoration: underline;
  text-transform: uppercase;
}

.quiet:hover {
  color: var(--brand-petrol);
}

.quiet:focus-visible {
  outline: 2px solid var(--focus-ring-color);
  outline-offset: 2px;
  border-radius: 2px;
}
